<!--Edit Panel Code  -->
<p-dialog [(visible)]="finraExceptionService.showCreateParentScreen" header="Creating Parent" height="auto" width="auto"
  [style]="{width: '78%', minWidth: '550px', minHeight: '150px'}" [maximizable]="true" minimizeIcon="pi pi-window-minimize"
  maximizeIcon="pi pi-window-maximize" closeIcon="pi pi-times" [modal]="false" draggable="false"
  styleClass="create-parent-dialog">

    @if(this.totalRecords > 0){
    <div class="ui-grid-col-12 container createParentTitle"> You are creating parents for {{totalRecords}} records</div>
    }
    <div class="ui-grid-col-12 container">
      @if(isLoadingResults){
      <div class="example-loading-shade">
        <mat-spinner diameter="50"></mat-spinner>
      </div>
      }
      <!-- Create Parent Form -->
      @for(viewRow of createParentColumnDetails; track viewRow.ui_Field_Name + '-'+ $index) {
      <span [ngClass]="'zindex ui-g-12 ui-md-12 ui-lg-4'">
        <span>
          <div class="ui-g-12 ui-md-12 ui-lg-12 quick-view-grid-row-hg">
            <div [ngClass]="'ui-g-12 ui-md-6 ui-lg-6 quick-view-grid-row-hg'">
              <label for="ui_Field_Name">{{viewRow.ui_Field_Name}}</label>
              @if(viewRow.isrequired){
              <strong class="error-mark">*</strong>
              }
            </div>
            <div [ngClass]="'ui-g-12 ui-md-6 ui-lg-6 quick-view-grid-row-hg'">
              <span>
                @if((viewRow?.datatype | lowercase) === 'string' && (viewRow?.dropdown | lowercase) === 'no'){
                <ng-container>
                  <input pInputText [id]="viewRow.field_Name+'string'" [(ngModel)]="viewRow.value" [disabled]="viewRow.isDisable" 
                  [maxlength]="viewRow.maximumLength" [placeholder]="(viewRow.placeholder ? viewRow.placeholder : '')" autocomplete="off" 
                  [ngClass]="((viewRow.errorFields && viewRow.errorFields.length > 0) ? 'errorField' : '')" 
                  class="input-field"/>
                  <div [ngClass]="'text-error'">{{(viewRow.errorFields && viewRow.errorFields.length > 0 ? viewRow['errorFields'] : '')}}</div>
                </ng-container>
                }
                @if((viewRow?.datatype | lowercase) === 'string' && (viewRow?.dropdown | lowercase) === 'yes' && (viewRow?.dropdowntype | lowercase) === 'singleselect'){
                <ng-container>
                  <p-select appendTo="body" [name]="viewRow.field_Name +'singleselect'" [id]="viewRow.field_Name+'singleselect'" 
                    [options]="viewRow.dropdownvalue" [(ngModel)]="viewRow.value" [disabled]="viewRow.isDisable" [showClear]="true" 
                    [placeholder]="'Enter Value'" class="maxChoiceWidth" [ngClass]="((viewRow.errorFields && viewRow.errorFields.length > 0) ? 'errorDropdownField' : '')"
                    styleClass="maxChoiceWidth">
                  </p-select>
                  <span [ngClass]="'text-error'">{{(viewRow.errorFields && viewRow.errorFields.length > 0 ? viewRow['errorFields'] : '')}}</span>
                </ng-container>
                }
              </span>
            </div>
          </div>
        </span>
      </span>
      }
      <!-- End of Create Parent Form -->
    </div>

    <ng-template #footer>
    <div class="ui-dialog-buttonpane ui-helper-clearfix">
      <button pButton type="button" icon="fa fa-close" id="createParentClose" class="userActionBtn create-parent-button" (click)="onClose();" label="Cancel"></button>
      <button pButton type="button" icon="fa fa-check" [disabled]="isClickedOnce" class="userActionBtn create-parent-button" (click)="onSave()" id="createParentSave" label="Ok"></button>
    </div>
    </ng-template>
</p-dialog>